import { p } from "./_helpers";

const elevage = {
 slug: "elevage",
 path: "/secteurs/elevage",
 hero: {
 image: "/photos/sector-elevage-hero.jpg",
 alt: p("Élevage traditionnel en Guinée-Bissau", "Traditional livestock in Guinea-Bissau", "Pecuária tradicional na Guiné-Bissau"),
 breadcrumb: p("Élevage", "Livestock", "Pecuária"),
 title: p("Investir dans l'élevage.", "Investing in livestock.", "Investir na pecuária."),
 subtitle: p(
 "Bovins N'Dama, petits ruminants, aviculture, pisciculture : un cheptel adapté aux terroirs, encore peu structuré en filières.",
 "N'Dama cattle, small ruminants, poultry, aquaculture: livestock adapted to the terroirs, still lightly structured into value chains.",
 "Bovinos N'Dama, pequenos ruminantes, avicultura, piscicultura: um efectivo adaptado aos terroirs, ainda pouco estruturado em fileiras."
 ),
 },
 seo: {
 title: p(
 "Investir dans l'élevage en Guinée-Bissau | NANDA SÁ",
 "Investing in livestock in Guinea-Bissau | NANDA SÁ",
 "Investir na pecuária na Guiné-Bissau | NANDA SÁ"
 ),
 description: p(
 "Panorama de l'élevage en Guinée-Bissau : bovins N'Dama, petits ruminants, aviculture, pisciculture. Chiffres clés, opportunités d'investissement et passerelles NANDA SÁ.",
 "Livestock panorama in Guinea-Bissau: N'Dama cattle, small ruminants, poultry, aquaculture. Key figures, investment opportunities and NANDA SÁ pathways.",
 "Panorama da pecuária na Guiné-Bissau: bovinos N'Dama, pequenos ruminantes, avicultura, piscicultura. Dados-chave, oportunidades de investimento e pontes NANDA SÁ."
 ),
 keywords: "élevage Guinée-Bissau, bovins N'Dama, aviculture Afrique de l'Ouest, pisciculture Guinée-Bissau, filière viande CEDEAO",
 },
 presentation: {
 title: p("Un cheptel adapté, une filière à bâtir.", "Livestock adapted, a value chain to build.", "Um efectivo adaptado, uma fileira por construir."),
 paragraphs: p(
 [
 "L'élevage en Guinée-Bissau repose sur des races locales robustes, au premier rang desquelles le bovin N'Dama, résistant à la trypanosomiase et parfaitement adapté à l'humidité soudano-guinéenne. À cela s'ajoutent les petits ruminants (moutons Djallonké, chèvres du Sahel), une aviculture rurale importante et une pisciculture émergente dans les bolongs.",
 "Ces filières restent largement informelles. Elles offrent aux investisseurs une opportunité rare : structurer un marché de la protéine animale ouest-africain qui croît de 4 à 5 % par an, en s'appuyant sur des cheptels déjà présents et sur une demande urbaine soutenue à Bissau.",
 ],
 [
 "Livestock in Guinea-Bissau relies on robust local breeds, foremost among them the N'Dama cattle, resistant to trypanosomiasis and perfectly adapted to Sudano-Guinean humidity. To this is added small ruminants (Djallonké sheep, Sahelian goats), significant rural poultry, and emerging aquaculture in the bolongs.",
 "These value chains remain largely informal. They offer investors a rare opportunity: to structure a West African animal protein market growing at 4-5% per year, drawing on herds already present and on sustained urban demand in Bissau and Bissau.",
 ],
 [
 "A pecuária na Guiné-Bissau assenta em raças locais robustas, em primeiro lugar o bovino N'Dama, resistente à tripanossomíase e perfeitamente adaptado à humidade sudano-guineense. A isto acrescentam-se os pequenos ruminantes (ovinos Djallonké, caprinos do Sahel), uma avicultura rural importante e uma piscicultura emergente nos bolongs.",
 "Estas fileiras permanecem largamente informais. Oferecem aos investidores uma oportunidade rara: estruturar um mercado da proteína animal oeste-africano que cresce 4 a 5 % ao ano, apoiando-se em efectivos já presentes e numa procura urbana sustentada em Bissau e Bissau.",
 ]
 ),
 },
 kpis: {
 title: p("Chiffres clés de l'élevage", "Livestock key figures", "Dados-chave da pecuária"),
 items: [
 { n: "1,5 M", l: p("Bovins N'Dama", "N'Dama cattle", "Bovinos N'Dama"), d: p("Cheptel bissau-guinéen.", "Bissau-Guinean herd.", "Efectivo bissau-guineense.") },
 { n: "4-5 %", l: p("Croissance annuelle", "Annual growth", "Crescimento anual"), d: p("Demande urbaine en protéine animale en Afrique de l'Ouest.", "Urban demand for animal protein in West Africa.", "Procura urbana de proteína animal na África Ocidental.") },
 { n: "70 %", l: p("Élevage traditionnel", "Traditional farming", "Pecuária tradicional"), d: p("Peu de fermes industrielles : marché à structurer.", "Few industrial farms: market to structure.", "Poucas explorações industriais: mercado a estruturar.") },
 { n: "3", l: p("Marchés à bétail", "Livestock markets", "Mercados pecuários"), d: p("Bissau, Bafatá, Kolda : hubs de commercialisation.", "Bissau, Bafatá, Kolda: trading hubs.", "Bissau, Bafatá, Kolda: polos de comercialização.") },
 { n: "€ 3-5/kg", l: p("Poulet fermier", "Farm chicken", "Frango caseiro"), d: p("Prix de vente urbain, marges attractives.", "Urban retail price, attractive margins.", "Preço de venda urbano, margens atractivas.") },
 { n: "Bolongs", l: p("Pisciculture", "Aquaculture", "Piscicultura"), d: p("Réseau naturel exceptionnel encore sous-exploité.", "Exceptional natural network still underexploited.", "Rede natural excepcional ainda sub-explorada.") },
 ],
 sources: p(
 "Sources : FAO, ministère de l'Élevage de la Guinée-Bissau, ANIDA, Banque mondiale, données 2022-2025.",
 "Sources: FAO, Guinea-Bissau Ministry of Livestock, ANIDA Guinée-Bissau, World Bank, data 2022-2025.",
 "Fontes: FAO, Ministério da Pecuária da Guiné-Bissau, ANIDA, Banco Mundial, dados 2022-2025."
 ),
 },
 opportunites: {
 title: p("Segments d'investissement prioritaires", "Priority investment segments", "Segmentos de investimento prioritários"),
 intro: p(
 "Quatre segments à haute valeur ajoutée, avec des tickets d'entrée accessibles.",
 "Four high value-added segments, with accessible entry tickets.",
 "Quatro segmentos de alto valor acrescentado, com tickets de entrada acessíveis."
 ),
 segments: [
 { h3: p("1. Aviculture semi-industrielle", "1. Semi-industrial poultry", "1. Avicultura semi-industrial"),
 p: p("Poulets de chair et pondeuses : demande urbaine forte à Bissau, Bafatá. Ticket : 50 000 à 200 000 €.", "Broilers and layers: strong urban demand in Bissau, Bafatá. Ticket: €50k to €200k.", "Frangos e poedeiras: forte procura urbana em Bissau, Bafatá. Ticket: 50 000 a 200 000 €.") },
 { h3: p("2. Embouche bovine et petits ruminants", "2. Cattle and small ruminant fattening", "2. Engorda bovina e pequenos ruminantes"),
 p: p("Valorisation des cheptels N'Dama et Djallonké pour l'export CEDEAO. Ticket : 80 000 à 300 000 €.", "Value creation from N'Dama and Djallonké herds for ECOWAS export. Ticket: €80k to €300k.", "Valorização dos efectivos N'Dama e Djallonké para a exportação CEDEAO. Ticket: 80 000 a 300 000 €.") },
 { h3: p("3. Pisciculture en bolong (tilapia, mulet)", "3. Bolong aquaculture (tilapia, mullet)", "3. Piscicultura em bolong (tilápia, tainha)"),
 p: p("Aquaculture douce, faible impact, forte marge. Ticket : 40 000 à 150 000 €.", "Freshwater aquaculture, low impact, high margin. Ticket: €40k to €150k.", "Aquacultura doce, baixo impacto, forte margem. Ticket: 40 000 a 150 000 €.") },
 { h3: p("4. Chaîne du froid & abattoirs modernes", "4. Cold chain & modern abattoirs", "4. Cadeia de frio e matadouros modernos"),
 p: p("Le maillon manquant de la filière. Ticket : 200 000 à 700 000 €.", "The missing link of the value chain. Ticket: €200k to €700k.", "O elo em falta da fileira. Ticket: 200 000 a 700 000 €.") },
 ],
 },
 defis: {
 title: p("Les défis à anticiper", "Challenges to anticipate", "Desafios a antecipar"),
 intro: p(
 "L'élevage récompense la rigueur sanitaire et la patience commerciale.",
 "Livestock rewards sanitary rigour and commercial patience.",
 "A pecuária recompensa o rigor sanitário e a paciência comercial."
 ),
 items: p(
 [
 "Un dispositif vétérinaire encore fragile, à renforcer par des partenariats privés.",
 "Une chaîne du froid quasi absente hors des grandes villes.",
 "Une forte saisonnalité des prix, à lisser par le stockage et l'embouche.",
 "Un besoin d'accompagnement technique des éleveurs traditionnels.",
 ],
 [
 "A still-fragile veterinary system, to be strengthened by private partnerships.",
 "A cold chain almost absent outside major cities.",
 "Strong seasonality of prices, to be smoothed by storage and fattening.",
 "A need for technical support to traditional herders.",
 ],
 [
 "Um dispositivo veterinário ainda frágil, a reforçar por parcerias privadas.",
 "Uma cadeia de frio quase ausente fora das grandes cidades.",
 "Uma forte sazonalidade dos preços, a suavizar pelo armazenamento e engorda.",
 "Uma necessidade de acompanhamento técnico dos criadores tradicionais.",
 ]
 ),
 closing: p(
 "Ces défis sont autant d'espaces où des investisseurs méthodiques construisent des positions durables.",
 "These challenges are so many spaces where methodical investors build lasting positions.",
 "Estes desafios são outros tantos espaços onde investidores metódicos constroem posições duradouras."
 ),
 },
 pourquoi: {
 title: p("Un partenaire ancré dans les terroirs.", "A partner rooted in the terroirs.", "Um parceiro enraizado nos terroirs."),
 paragraphs: p(
 [
 "NANDA SÁ travaille avec des coopératives, des éleveurs et des groupements féminins depuis 2023. Nous connaissons les circuits, les marchés hebdomadaires, les vétérinaires et les acheteurs urbains. Nous concevons chaque projet comme une infrastructure sanitaire et commerciale, non comme une simple ferme.",
 ],
 [
 "NANDA SÁ works with cooperatives, herders and women's groups since 2023. We know the circuits, weekly markets, veterinarians and urban buyers. We design every project as sanitary and commercial infrastructure, not as a mere farm.",
 ],
 [
 "A NANDA SÁ trabalha com cooperativas, criadores e grupos femininos desde 2023. Conhecemos os circuitos, os mercados semanais, os veterinários e os compradores urbanos. Concebemos cada projecto como infra-estrutura sanitária e comercial, não como uma simples exploração.",
 ]
 ),
 bullets: p(
 [
 "Étude d'implantation et zoning élevage",
 "Partenariats vétérinaires et coopératives",
 "Structuration commerciale et chaîne du froid",
 "Recrutement et formation des équipes",
 ],
 [
 "Establishment and livestock zoning study",
 "Veterinary and cooperative partnerships",
 "Commercial structuring and cold chain",
 "Recruitment and team training",
 ],
 [
 "Estudo de implantação e zoneamento pecuário",
 "Parcerias veterinárias e cooperativas",
 "Estruturação comercial e cadeia de frio",
 "Recrutamento e formação de equipas",
 ]
 ),
 },
 download: {
 title: p("Télécharger la note « Élevage · Guinée-Bissau ».", "Download the brief « Livestock · Guinea-Bissau ».", "Descarregar a nota « Pecuária · Guiné-Bissau »."),
 body: p(
 "Note préparée par NANDA SÁ : chiffres clés, segments d'investissement, cadre sanitaire, contacts utiles.",
 "Brief prepared by NANDA SÁ: key figures, investment segments, sanitary framework, useful contacts.",
 "Nota preparada pela NANDA SÁ: dados-chave, segmentos de investimento, enquadramento sanitário, contactos úteis."
 ),
 pdfUrl: "/pdf/nanda-sa-note-elevage.pdf",
 pdfFilename: "nanda-sa-note-elevage.pdf",
 mailSubject: p("Téléchargement de la note « Élevage »", "Download of the brief « Livestock »", "Descarga da nota « Pecuária »"),
 mailBody: p(
 "Bonjour, je souhaite recevoir la note « Élevage · Guinée-Bissau ».",
 "Hello, I would like to receive the brief « Livestock · Guinea-Bissau ».",
 "Olá, gostaria de receber a nota « Pecuária · Guiné-Bissau »."
 ),
 },
 contact: {
 title: p("Parlons de votre projet d'élevage.", "Let's talk about your livestock project.", "Falemos do seu projecto pecuário."),
 body: p(
 "Éleveur, investisseur, industriel, coopérative : décrivez votre intention, nous répondons personnellement.",
 "Herder, investor, industrialist, cooperative: describe your intention, we respond personally.",
 "Criador, investidor, industrial, cooperativa: descreva a sua intenção, respondemos pessoalmente."
 ),
 quote: p(
 "Un cheptel est une richesse qui se construit lentement. C'est aussi une richesse qui se transmet.",
 "A herd is wealth built slowly. It is also wealth that is passed on.",
 "Um efectivo é uma riqueza que se constrói lentamente. É também uma riqueza que se transmite."
 ),
 subject: p("Investir dans l'élevage en Guinée-Bissau", "Invest in livestock in Guinea-Bissau", "Investir na pecuária na Guiné-Bissau"),
 },
 ctas: ["NandaSa", "Conseil"],
};

export default elevage;
